module.exports = __webpack_public_path__ + "img/marquard.dad9fd61.jpg";